import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type MetricSummary = {
  current?: number
  previous?: number
  trend?: number
}

type TimeToCompleteBreakdown = {
  timeslice: string
  avg_ttc?: string
}

type TimeToCompleteMetrics = {
  taskCount: MetricSummary
  taskAverage: MetricSummary
  breakdown: TimeToCompleteBreakdown[]
}

export const PROGRAM_TASK_COMPLETION_STATS_KEY = 'program-task-completion-stats'

export function useGetTaskCompletion(
  programId: string | undefined,
  period: { start: string; end: string } | undefined,
  granularity: 'monthly' | 'daily' | 'weekly'
) {
  return useQuery({
    queryKey: [PROGRAM_TASK_COMPLETION_STATS_KEY, programId, period?.start, period?.end, granularity],
    queryFn: async () => {
      const { data } = await apiClient.get<TimeToCompleteMetrics>(`/int/stats/program/task-completion`, {
        params: {
          program_id: programId,
          start_time: period!.start,
          end_time: period!.end,
          granularity,
        },
      })

      return data
    },
    enabled: Boolean(programId) && Boolean(period?.start) && Boolean(period?.end) && Boolean(granularity),
  })
}
